import React, {
  useEffect,
  useState,
  useRef,
  useCallback,
  useMemo,
  useContext,
} from "react";
import axios from "axios";
import Select from "react-select";
import * as XLSX from "xlsx";

import { useParams, Link } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import jsPDF from "jspdf";
import JsBarcode from "jsbarcode";
import html2canvas from "html2canvas";
import { toastError, toastSuccess } from "../../../common/Toast";
import {
  CUSTOM_SELECT_DROPDOWN_STYLE,
  DATA_EXPORT,
  ERROR_MESSAGE,
} from "../../../common/Constant";
import { Calendar } from "../../../common/imagePath";
import ReactDatetime from "react-datetime";
import moment from "moment";
import ReportDate from "../../../components/Reports/ReportDate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";

//--------Material React Table------//
import { MaterialReactTable } from "material-react-table";
import { Box, Button } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { Stack } from "react-bootstrap";
import CommonMatrialReactTable from "../../../components/Datatable/CommonMatrialReactTable";
import { AppContext } from "../../../context/AppContext";
import CurrencySymbols from "../../../common/CurrencySymbol";

const currentDate = new Date();
const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const month = monthNames[currentDate.getMonth()]; // add 1 to get month value from 1 to 12
const hours = currentDate.getUTCHours();
const minutes = currentDate.getUTCMinutes();

const AccountsPayableAgingDetail = (props) => {
  const token = localStorage.getItem("Token");
  const locationid = localStorage.getItem("Location");
  const { CurrencySymbol, FractionDigits, dateFormate } =
    useContext(AppContext);
  const [formValues, setFormValues] = useState([]);
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalSum, setTotalSum] = useState(0);
  const [totalbalance, setTotalBalance] = useState(0);
  const [columnby, setcolumnby] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");
  const [selectedDate, setSelectedDate] = useState([]);
  const [selectReport, setSelectReport] = useState(7);
  const [activeAccordion, setActiveAccordion] = useState(null);
  const [agingPeriod, setAgingPeriod] = useState(30);
  const [numberPeriod, setNumberPeriod] = useState(4);
  const [mindayspastdue, setMindayspastdue] = useState(0);
  const [dataResponse, setDataResponse] = useState([]);

  //----------------Server-Side------------------//
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });

  const handleDropdownChange = (event) => {
    // const selectedValue = event.target.value;
    setSelectReport(event?.value);
    console.log(event.target.value);
    if (event?.value == 1) {
      setStartDate("");
      setEndDate("");
    }
  };

  const toggleAccordion = (index) => {
    setActiveAccordion(activeAccordion === index ? null : index);
  };

  const renderAccordionIcon = (index) => {
    if (activeAccordion === index) {
      return <FontAwesomeIcon icon={faChevronUp} />;
    } else {
      return <FontAwesomeIcon icon={faChevronDown} />;
    }
  };

  //Function for lookup receipt
  const paramObject = useParams();
  const apicall = () => {
    const columnIndex = sorting.length > 0 ? sorting[0]?.id : "";

    const FilterColumnText = {};
    FilterColumnText.filtercolumntext = columnFilters.map((el, index) => {
      return { columnname: el.id, value: el.value, id: index + 1 };
    });

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);
    setLoading(true);
    setResponseData([]);
    axios
      .get(
        `${
          config.reportsBaseUrl
        }/reports/payableagingdetail?daysperagingperiod=${agingPeriod}&numberofperiods=${numberPeriod}&mindayspastdue=${mindayspastdue}&filtercolumnsearchtext=&currentorder=&ordercolumn=${columnIndex}&pagesize=${
          pagination.pageSize
        }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
          globalFilter === undefined ? "" : globalFilter
        }&startdate=${startdate}&enddate=${enddate}&locationid=${locationid}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          const FilterData = res.data.ResponseData?.map((el) => ({
            ...el,
            OpenBalance: Number(el?.OpenBalance),
            Amount: Number(el?.Amount),
          }));
          setResponseData(FilterData);

          console.log("11", responseData);
          //   barcodeRefs.current = responseData;
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  // useEffect(() => {
  //   if (
  //     (agingPeriod === undefined || agingPeriod === "") &&
  //     (numberPeriod === undefined || numberPeriod === "")
  //   ) {
  //     toastError("Days per aging period or Number of periods can't be empty");
  //     return;
  //   } else if (agingPeriod === undefined || agingPeriod === "") {
  //     toastError("Please enter a number between 1 to 500");
  //     return;
  //   } else if (numberPeriod === undefined || numberPeriod === "") {
  //     toastError("Please enter a number between 1 to 50");
  //     return;
  //   } else {
  //     apicall();
  //   }
  // }, [
  //   columnFilters,
  //   globalFilter,
  //   pagination.pageIndex,
  //   pagination.pageSize,
  //   sorting,
  //   startdate,
  //   enddate,
  //   agingPeriod,
  //   numberPeriod,
  //   mindayspastdue,
  // ]);

  useEffect(() => {
    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("setSelectedDate======>", res);
        setSelectedDate(res.data.ResponseData);
        // setLoading(false);
        return res;
      });
  }, [startdate, enddate]);

  // to calculate the total
  const calculateTotalSum = () => {
    const sum = responseData.reduce((total, report) => {
      const reportTotal = Number(report.Amount);

      if (typeof reportTotal === "number" && !isNaN(reportTotal)) {
        return total + reportTotal;
      } else {
        return total;
      }
    }, 0);

    setTotalSum(sum);
  };

  const calculateTotalbalance = () => {
    const sum = responseData.reduce((total, report) => {
      const reportTotal = Number(report.OpenBalance);

      if (typeof reportTotal === "number" && !isNaN(reportTotal)) {
        return total + reportTotal;
      } else {
        return total;
      }
    }, 0);
    setTotalBalance(sum);
  };

  useEffect(() => {
    calculateTotalSum();
    calculateTotalbalance();
  }, [responseData]);

  const callback = (payload, enddate2) => {
    console.log("stardate =>", payload);
    setStartDate(payload);
    setEndDate(enddate2);

    console.log("enddate =>", enddate2);
  };
  const [openBalance, setOpenBalance] = useState([]);

  const columns = useMemo(() => [
    // {
    //   header: "Period",
    //   accessorKey: "Period",
    //   size: "120",
    // },
    // {
    //   header: "Date",
    //   accessorKey: "Date",
    //   size: "120",
    //   Cell: ({ row }) => {
    //     const Date = moment(row.original.Date);
    //     if (Date.isValid()) {
    //       return Date.format("YYYY-MM-DD(HH:mm)");
    //     } else {
    //       return "";
    //     }
    //   },
    // },
    // {
    //   header: "Transaction Type",
    //   accessorKey: "TransactionType",
    //   size: "120",
    // },
    // {
    //   header: "NUM",
    //   accessorKey: "NUM",
    //   size: "120",
    // },
    // {
    //   header: "Vendor",
    //   accessorKey: "Vendor",
    //   size: "120",
    // },
    // {
    //   header: "Due Date",
    //   accessorKey: "DueDate",
    //   Cell: ({ row }) => moment(row.original.DueDate).format("YYYY-MM-DD"),
    //   size: "140",
    // },
    // {
    //   header: "Past Due",
    //   accessorKey: "PastDue",
    //   size: "120",
    // },
    // {
    //   header: "Amount",
    //   accessorKey: "Amount",
    //   Cell: ({ row }) => parseFloat(row.original.Amount).toFixed(2),
    //   size: "120",
    // },
    // {
    //   header: "Open Balance",
    //   accessorKey: "OpenBalance",
    //   Cell: ({ row }) => parseFloat(row.original.OpenBalance).toFixed(2),
    //   size: "120",
    // },

    {
      header: "Date",
      accessorKey: "Date",
      size: 110,
      Cell: ({ row }) => {
        return moment(row.original.Date).format(`${dateFormate.toUpperCase()}`);
      },
    },
    {
      header: "Transaction Type",
      accessorKey: "TransactionType",
      Cell: ({ row }) => (
        <Box
          component="span"
          sx={{
            borderRadius: "0.3rem",
            color: "#343f62",
            maxWidth: "18ch",
            textDecoration: "underline",
            textUnderlineOffset: "3px",
            p: "0.3rem",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            fontWeight: "700",
          }}
          onClick={() => {
            const url =
              row.original?.TransactionType === "Payment"
                ? `/receiving-paybills/${row.original.TxnID}`
                : row.original?.TransactionType === "Bill" ||
                  row.original?.TransactionType === "Vendor Credit"
                ? `/receiving-receipt/${row.original.TxnID}`
                : row.original?.TransactionType === "Journal Entry"
                ? `/journal-entry/${row.original.TxnID}`
                : row.original?.TransactionType === "Deposit"
                ? `/bank-deposit/${row.original.TxnID}`
                : `/Expense/${row.original.TxnID}`;

            window.open(url, "_blank"); // Open in a new tab
          }}
        >
          {row.original.TransactionType}
        </Box>
      ),
    },
    {
      header: "Num",
      accessorKey: "Num",
      size: 110,
    },
    {
      header: "Supplier",
      accessorKey: "Customer",
    },
    {
      header: "Due Date",
      accessorKey: "DueDate",
      size: 110,
      Cell: ({ row }) => {
        const DueDate = row?.original?.DueDate;
        if (DueDate === "0000-00-00" || DueDate === "" || DueDate === null) {
          return "";
        }
        return moment(DueDate).format(`${dateFormate.toUpperCase()}`);
      },
    },
    {
      header: "Amount",
      accessorKey: "Amount",
      size: 120,
      Cell: ({ row }) => {
        return (
          <div style={{ textAlign: "end" }}>
            {CurrencySymbols(
              Number(row.original.Amount),
              { CurrencySymbol },
              FractionDigits
            )}
          </div>
        );
      },
      AggregatedCell: ({ cell, table }) => {
        const groupingColumnId = cell.row.groupingColumnId ?? "";
        const originalValue =
          cell.row.original?.[groupingColumnId] ??
          cell.row.subRows?.[0]?.original?.[groupingColumnId];

        // Retrieve the aggregated value
        const aggregatedValue = cell.getValue();

        // Check if the value is valid and format it
        const formattedValue =
          typeof aggregatedValue === "number" ? aggregatedValue : 0;

        return (
          <>
            <Box component="span" sx={{ fontWeight: "bold" }}>
              Total for {originalValue ?? "Unknown"}:
            </Box>{" "}
            <Box
              sx={{ color: "info.main", display: "inline", fontWeight: "bold" }}
            >
              {/* {formattedValue} */}
              {CurrencySymbols(
                Number(formattedValue),
                { CurrencySymbol },
                FractionDigits
              )}
            </Box>
          </>
        );
      },
      Footer: () => (
        <>
          <div style={{ textAlign: "end" }}>
            <Stack>
              Total:
              <Box color="warning.main">
                {CurrencySymbols(
                  Number(totalSum),
                  { CurrencySymbol },
                  FractionDigits
                )}
              </Box>
            </Stack>
          </div>
        </>
      ),
    },
    {
      header: "Open Balance",
      accessorKey: "OpenBalance",
      size: 120,
      Cell: ({ row }) => {
        return (
          <div style={{ textAlign: "end" }}>
            {CurrencySymbols(
              Number(row.original.OpenBalance),
              { CurrencySymbol },
              FractionDigits
            )}
          </div>
        );
      },
      AggregatedCell: ({ cell, table }) => {
        const groupingColumnId = cell.row.groupingColumnId ?? "";
        const originalValue =
          cell.row.original?.[groupingColumnId] ??
          cell.row.subRows?.[0]?.original?.[groupingColumnId];

        // Retrieve the aggregated value
        const aggregatedValue = cell.getValue();

        // Check if the value is valid and format it
        const formattedValue =
          typeof aggregatedValue === "number" ? aggregatedValue : 0;

        return (
          <>
            <Box component="span" sx={{ fontWeight: "bold" }}>
              Total for {originalValue ?? "Unknown"}:
            </Box>{" "}
            <Box
              sx={{ color: "info.main", display: "inline", fontWeight: "bold" }}
            >
              {/* {formattedValue} */}
              {CurrencySymbols(
                Number(formattedValue),
                { CurrencySymbol },
                FractionDigits
              )}
            </Box>
          </>
        );
      },
      Footer: () => (
        <>
          <div style={{ textAlign: "end" }}>
            <Stack>
              Total:
              <Box color="warning.main">
                {CurrencySymbols(
                  Number(totalbalance),
                  { CurrencySymbol },
                  FractionDigits
                )}
              </Box>
            </Stack>
          </div>
        </>
      ),
    },
    {
      header: "Create Date",
      accessorKey: "CreateDate",
      Cell: ({ row }) => {
        const CreatedDate = row?.original?.CreatedDate;
        if (
          CreatedDate === "0000-00-00" ||
          CreatedDate === "" ||
          CreatedDate === null
        ) {
          return "";
        }
        return moment(CreatedDate).format(
          `${dateFormate.toUpperCase()} hh:mm A`
        );
      },
    },
    {
      header: "Created By",
      accessorKey: "CreatedBy",
      size: 120,
    },
    {
      header: "Last Modified",
      accessorKey: "LastModified",
      Cell: ({ row }) => {
        const LastModified = row?.original?.LastModified;
        if (
          LastModified === "0000-00-00" ||
          LastModified === "" ||
          LastModified === null
        ) {
          return "";
        }
        return moment(LastModified).format(
          `${dateFormate.toUpperCase()} hh:mm A`
        );
      },
    },
    {
      header: "Last Modified By",
      accessorKey: "LastModifiedBy",
      size: 120,
    },
    {
      header: "Phone",
      accessorKey: "Phone",
      size: 120,
    },
    {
      header: "Email",
      accessorKey: "Email",
    },
    {
      header: "FullName",
      accessorKey: "FullName",
    },
    {
      header: "Address",
      accessorKey: "Address",
    },
    {
      header: "Company Name",
      accessorKey: "CompanyName",
    },
    {
      header: "Past Due",
      accessorKey: "DaysPastDue",
    },
    {
      header: "Memo Description",
      accessorKey: "MemoDescription",
    },
    {
      header: "Aging Period",
      accessorKey: "AgingPeriod",
    },
  ]);

  let reportdropdown = [];
  const data2 = selectedDate.map(
    (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
  );

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/reports">Report</Link>
                </li>
                <li className="breadcrumb-item active">
                  Accounts Payable Aging Detail
                </li>
              </ul>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-3">
              {/* <div className="row"> */}
              {/* <div className="col-md-4 z-3"> */}
              <label className="col-form-label form-label p-lg-medium">
                Report period
              </label>
              <Select
                styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                options={reportdropdown}
                // defaultValue={selectReport}
                backspaceRemovesValue={false}
                controlShouldRenderValue={true}
                hideSelectedOptions={true}
                // isClearable={true}
                name="Reportperiod"
                id="Reportperiod"
                value={reportdropdown.find((e) => e.value === selectReport)}
                onChange={(event) => {
                  handleDropdownChange(event);
                }}
                className="custom-search-select"
              ></Select>
            </div>
            {(selectReport == 2 ||
              selectReport == 3 ||
              selectReport == 4 ||
              selectReport == 5 ||
              selectReport == 6 ||
              selectReport == 7 ||
              selectReport == 8 ||
              selectReport == 9 ||
              selectReport == 10 ||
              selectReport == 11 ||
              selectReport == 12 ||
              selectReport == 13 ||
              selectReport == 14 ||
              selectReport == 15 ||
              selectReport == 16 ||
              selectReport == 17 ||
              selectReport == 18 ||
              selectReport == 19 ||
              selectReport == 20 ||
              selectReport == 21 ||
              selectReport == 22 ||
              selectReport == 23 ||
              selectReport == 24 ||
              selectReport == 25 ||
              selectReport == 26 ||
              selectReport == 27 ||
              selectReport == 28 ||
              selectReport == 29 ||
              selectReport == 30 ||
              selectReport == 31) &&
              selectReport !== 1 && (
                <div className="col-sm-3">
                  {/* <div className="row"> */}
                  <ReportDate
                    callback={callback}
                    selectReport={selectReport}
                    showhidecomponent={
                      selectReport == 2 ||
                      selectReport == 3 ||
                      selectReport == 4 ||
                      selectReport == 5 ||
                      selectReport == 6 ||
                      selectReport == 7 ||
                      selectReport == 8 ||
                      selectReport == 9 ||
                      selectReport == 10 ||
                      selectReport == 11 ||
                      selectReport == 12 ||
                      selectReport == 13 ||
                      selectReport == 14 ||
                      selectReport == 15 ||
                      selectReport == 16 ||
                      selectReport == 17 ||
                      selectReport == 18 ||
                      selectReport == 19 ||
                      selectReport == 20 ||
                      selectReport == 21 ||
                      selectReport == 22 ||
                      selectReport == 23 ||
                      selectReport == 24 ||
                      selectReport == 25 ||
                      selectReport == 26 ||
                      selectReport == 27 ||
                      selectReport == 28 ||
                      selectReport == 29 ||
                      selectReport == 30 ||
                      selectReport == 31
                        ? true
                        : false
                    }
                  />
                  {/* </div> */}
                </div>
              )}
            <div className="col-sm-2">
              <label className="col-form-label form-label">
                Days per aging period
              </label>
              <input
                className="form-control"
                name="agingperiod"
                id="agingperiod"
                value={agingPeriod}
                onChange={(e) => {
                  setAgingPeriod(e.target.value);
                }}
              ></input>
            </div>
            <div className="col-sm-2 ">
              <label className="col-form-label form-label">
                Number of periods
              </label>
              <input
                className="form-control"
                name="numberperiod"
                id="numberperiod"
                value={numberPeriod}
                onChange={(e) => {
                  setNumberPeriod(e.target.value);
                }}
              ></input>
            </div>
            <div className="col-sm-2 ">
              <label className="col-form-label form-label">
                Min. Days Past Due
              </label>
              <input
                className="form-control"
                name="numberperiod"
                id="numberperiod"
                onChange={(e) => {
                  setMindayspastdue(e.target.value);
                }}
              ></input>
            </div>
            <div className="col">
              {/* align-self-sm-end */}
              <label className="col-form-label col-md-12 form-label p-lg-medium">
                {""}
              </label>

              <button
                type="submit"
                className="btn btn-primary"
                // style={{ marginLeft: "auto" }}
                onClick={() => apicall()}
              >
                Run Report
              </button>
            </div>
          </div>
          {responseData.length > 0 && (
            <div className="card mt-3" id="print">
              <div className="card-body">
                <div className="container">
                  <div className="col-md-12 text-center" id="header">
                    <hp className="p">SonarPos</hp>
                    <p className="fw-bold p-regular">
                      Accounts Payable Aging Detail
                    </p>
                    <div className="row mb-2">
                      <p>
                        Date:{" "}
                        {startdate === "" && enddate === ""
                          ? "All Data"
                          : moment(startdate).format(
                              `${dateFormate.toUpperCase()}`
                            ) +
                            " - " +
                            moment(enddate).format(
                              `${dateFormate.toUpperCase()}`
                            )}
                      </p>
                    </div>
                  </div>
                </div>
                <hr />
                <div>
                  <CommonMatrialReactTable
                    MainHeading="Sonar POS"
                    ReportHeading="Accounts Payable Aging Detail"
                    columns={columns}
                    data={responseData}
                    startdate={startdate}
                    enddate={enddate}
                    columnGrouping={["AgingPeriod"]}
                    enableRowSelection={false}
                    enableExpandAll={true}
                    enableExpanding={true}
                    expanded={true}
                    columnsVisibility={{
                      CreateDate: false,
                      CreatedBy: false,
                      LastModified: false,
                      LastModifiedBy: false,
                      Phone: false,
                      Email: false,
                      FullName: false,
                      Address: false,
                      CompanyName: false,
                      DaysPastDue: false,
                      MemoDescription: false,
                    }}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default AccountsPayableAgingDetail;
